import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from 'react-router-dom';
import axios from "axios";
import MoreInfo from '../FormHeading/moreInfoHeading';
import Condos from '../FormHeading/condosHeading';
import VCard from '../FormHeading/vCardHeading';
import Header from '../Header/header';
import DownloadLinkMessage from '../Messages/downloadLinkMessage'
import GeneralMessage from '../Messages/generalMessage'
import Footer from '../Footer/footer'

const ContactForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const [downloadLink, setDownLoadLink] = useState(null);
  let params = useParams();

  const { register, handleSubmit, formState: { errors } } = useForm({
    mode: 'all',
  });

  useEffect(() => {
    if(downloadLink) {
      const a = document.createElement('a');
      a.style.display = 'none';
      a.setAttribute('href', downloadLink);
      a.setAttribute('download', `${process.env.REACT_APP_EXT}.${params.name}`); // desired filename
      document.body.appendChild(a);
      a.click();
      a.parentNode.removeChild(a);
    }
  }, [downloadLink, params.name]);

  const submit = async (data) => {
    const formattedData = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      cellPhone: data.cellPhone,
      consent: data.consent,
      sold: data.sold,
      preconstruction: data.preconstruction,
      name: params.name,
      scanId: params.scanId,
    };

    try {
      setSubmitted(true);
      const postRes = await axios.post(`/contact`, formattedData, {
        headers: {
          Accept: 'application/json',
        },
      });

      setDownLoadLink(postRes.data.signedUrl);
    } catch (error) {}
  };

  return (
    <div className='container max-w-max mx-auto pl-4 pr-4'>
      {submitted ? (
        downloadLink ? (
          <DownloadLinkMessage />
        ) : (
          <GeneralMessage />
        )
      ) : (
        <>
          <Header />
          <form
            action='submit'
            onSubmit={handleSubmit(submit)}
            className='flex flex-col justify-center items-center'
          >
            {params.name === 'more-info' ? (
              <MoreInfo />
            ) : params.name === 'condos' ? (
              <Condos />
            ) : (
              <VCard />
            )}
            <div>
              <div className='pb-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:pt-4'>
                <label
                  for='firstName'
                  className='text-primary text-opacity-75 block text-sm font-medium sm:mt-px sm:pt-2'
                >
                  First Name:
                </label>
                <div className='mt-1 sm:mt-0 sm:col-span-2'>
                  <input
                    {...register('firstName', { required: true })}
                    type='text'
                    name='firstName'
                    id='first-name'
                    autocomplete='given-name'
                    className='block max-w-lg w-full shadow-sm focus:ring-gray-300 focus:border-gray-300 sm:text-sm border-gray-300 rounded-md'
                  />
                  {errors.firstName && (
                    <p className='text-xs text-secondary'>
                      First Name Required
                    </p>
                  )}
                </div>
              </div>
              <div className='pb-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:pt-2'>
                <label
                  for='lastName'
                  className='text-primary text-opacity-75 block text-sm font-medium sm:mt-px sm:pt-2'
                >
                  Last Name:
                </label>
                <div className='mt-1 sm:mt-0 sm:col-span-2'>
                  <input
                    {...register('lastName', { required: true })}
                    type='text'
                    name='lastName'
                    id='last-name'
                    autocomplete='family-name'
                    className='block max-w-lg w-full shadow-sm focus:ring-gray-300 focus:border-gray-300 sm:text-sm border-gray-300 rounded-md'
                  />
                  {errors.lastName && (
                    <p className='text-xs text-secondary'>Last Name Required</p>
                  )}
                </div>
              </div>
              <div className='pb-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:pt-2'>
                <label
                  for='email'
                  className='text-primary text-opacity-75 block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2'
                >
                  Email:
                </label>
                <div className='mt-1 sm:mt-0 sm:col-span-2'>
                  <input
                    {...register('email', { required: true })}
                    id='email'
                    name='email'
                    type='email'
                    autocomplete='email'
                    className='block max-w-lg w-full shadow-sm focus:ring-gray-300 focus:border-gray-300 sm:text-sm border-gray-300 rounded-md'
                  />
                  {errors.email && (
                    <p className='text-xs text-secondary'>Email Required</p>
                  )}
                </div>
              </div>
              <div className='pb-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:pt-2'>
                <label
                  for='cellPhone'
                  className='text-primary text-opacity-75 block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2'
                >
                  Phone Number:
                </label>
                <div className='mt-1 sm:mt-0 sm:col-span-2'>
                  <div className='flex'>
                    <span class='inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm'>
                      +1
                    </span>
                    <input
                      {...register('cellPhone', {
                        required: params.name === 'condos' ? false : true,
                      })}
                      id='cell-phone'
                      name='cellPhone'
                      pattern='^(+1|1)?([2-9]dd[2-9]d{6})$'
                      type='number'
                      autocomplete='tel'
                      className='flex-1 block max-w-lg w-full shadow-sm focus:ring-gray-300 focus:border-gray-300 sm:text-sm border-gray-300 rounded-md'
                    />
                  </div>
                  {errors.cellPhone && (
                    <p className='text-xs text-secondary mb-1'>
                      Phone Number Required
                    </p>
                  )}
                  <input
                    {...register('consent', { required: true })}
                    name='consent'
                    type='checkbox'
                    className='text-secondary focus:ring-transparent focus:border-gray-300 border-2 border-gray-300 rounded-sm mr-2'
                  />
                  <span className='text-primary text-opacity-75 text-xs'>
                    I agree to receiving communications from Smart Investment
                  </span>
                  {errors.consent && (
                    <p className='text-xs text-secondary mb-1'>
                      Consent Required
                    </p>
                  )}
                  <div className='flex flex-col'>
                    <p className='text-primary text-sm text-opacity-75 mt-2'>I would like to receive:</p>
                    <div>
                      <input
                        {...register('sold')}
                        name='sold'
                        type='checkbox'
                        className='text-secondary focus:ring-transparent focus:border-gray-300 border-2 border-gray-300 rounded-sm mr-2'
                      />
                      <span className='text-primary text-opacity-75 text-xs'>
                        Updates about for sale &#38; sold in my neighbourhood
                      </span>
                    </div>
                    <div>
                      <input
                        {...register('preconstruction')}
                        name='preconstruction'
                        type='checkbox'
                        className='text-secondary focus:ring-transparent focus:border-gray-300 border-2 border-gray-300 rounded-sm mr-2'
                      />
                      <span className='text-primary text-opacity-75 text-xs'>
                        New Pre-construction opportunities in the market
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className='sm:grid sm:grid-cols-6 sm:gap-4 sm:col-span-3'>
                <button
                  type='submit'
                  className='sm:col-start-3 px-6 py-1 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-primary hover:bg-secondary activ:bg-secondary focus:outline-none mt-1'
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
          <Footer />
        </>
      )}
    </div>
  );
};

export default ContactForm;